import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { searchApplicables } from "MODULES/parts/actions/applications";
import { AutoComplete } from "MODULES/shared/components";
import {
  HIGHER_ASSEMBLY_APPLICATION,
  LOWER_ASSEMBLY_APPLICATION
} from "MODULES/parts/constants";

function format(type) {
  return result => {
    if (
      [HIGHER_ASSEMBLY_APPLICATION, LOWER_ASSEMBLY_APPLICATION].includes(type)
    ) {
      return result.part_number;
    }

    return result.model_number;
  };
}

export function Search({ type, search, onSelect, autoFocus }) {
  return (
    <AutoComplete
      autoFocus={autoFocus}
      search={search}
      onSelect={onSelect}
      format={format(type)}
      watch={type}
      allowUserInput={type === LOWER_ASSEMBLY_APPLICATION}
      selectOnBlur={false}
    />
  );
}

Search.propTypes = {
  type: PropTypes.string.isRequired,
  search: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired
};

export default connect(undefined, (dispatch, ownProps) => ({
  search: filter =>
    dispatch(searchApplicables(ownProps.type, ownProps.part)(filter))
}))(Search);



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/Applications/Applicable/Search.jsx